'use strict';

// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";

function J3WTheme() {

    var self = this;

    self.$window = $(window);
    self.$document = $(document);
    self.$body = $("body");
    self.$header = $("#js-header");
    self.$hamburger = $(".hamburger");
    self.$mainMenu = $("#js-main-menu");
    self.$mainNav = $("#main-nav");
    self.$mobileMenu = $("#js-mobile-menu");

    self.ajaxProductTabs = false;
    self.$jsAjaxEqpContent = $("#js-ajax-eqp-content");

    self.init();
}

J3WTheme.prototype = {

    init: function () {

        var self = this;

        self.onBind();
        self.cloneMainMenu();
        self.swiperHeroInit();
        self.fancybox();
      // V package.json je treba zafixovat verzi jsparoller na 1.4.4
      // Jinak se tam objevi chyba a odskakuje to pri scrollovani
        //self.parollerInit();
    },

    onBind: function () {

        var self = this;

        self.$window.on('scroll', function () {
            self.bodyScrollClass(self);
        });

        self.$hamburger.on("click", function () {
            self.mobileMenu();
        });

        $("#js-drones-tabs-nav").on("click", "a", function(e) {
            self.productTabsAjax( $(this).data("id") );
            self.productTabsToggle( $(this), "#js-ajax-drones-content" );
            e.preventDefault();
        });

        self.$body.on("click", "#js-equipments-tabs-nav a", function(e) {
            self.productTabsToggle( $(this), "#js-ajax-eqp-content" );
            e.preventDefault();
        });

    },

    mobileMenu: function(){

        var self = this, t;

        clearTimeout( t );

        //self.$body.toggleClass("mobile-menu-is-open");

        var $hamburger = $(".hamburger");

        if( self.$mobileMenu.hasClass("mobile-menu--open") ){
            self.$mobileMenu.removeClass("mobile-menu--open");
            t = setTimeout( function(){
                $hamburger.removeClass("is-active");
            }, 200 );
        }
        else {
            self.$mobileMenu.addClass("mobile-menu--open");
            t = setTimeout( function(){
                $hamburger.addClass("is-active");
            }, 200 );
        }

    },

    cloneMainMenu: function(){

        $("#js-main-menu:not(.cloned)").addClass("cloned")
            .clone( true, true )
            .removeAttr("id")
            .appendTo("#js-sticky-menu-container");

    },

    bodyScrollClass: function ( self ) {

        if( self.$document.scrollTop() > self.$header.outerHeight() ) {
            self.$body.addClass('js-scrolling');
        }
        else {
            self.$body.removeClass('js-scrolling');
        }
/*
        // potrebujeme vedet, jestli se scrolluje dolu nebo nahoru
        if ( ( document.body.getBoundingClientRect() ).top > self.scrollPos ) {
            self.$body.addClass('scroll-up');
        } else {
            self.$body.removeClass('scroll-up');
        }

        self.scrollPos = ( document.body.getBoundingClientRect() ).top;

        if( self.$document.scrollTop() < self.$header.outerHeight() + 100 ) {
            self.$body.addClass('hide-menu');
        } else {
            self.$body.removeClass('hide-menu');
        }
*/
    },

    swiperHeroInit: function() {

        var self = this;

        self.swiperHero = new Swiper('#js-swiper-hero', {
            loop: true,
            speed: 600,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: false,
            lazyLoading: true,
            lazy: {
                loadPrevNext: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }
        });
    },

    fancybox: function() {

        $('[data-fancybox="gallery"]').fancybox({
            loop: true,
            buttons: [
                "zoom",
                "share",
                "slideShow",
                "fullScreen",
                //"download",
                //"thumbs",
                "close"
            ]
        });
    },

    parollerInit: function() {
      // V package.json je treba zafixovat verzi na 1.4.4
      // Jinak se tam objevi chyba a odskakuje to pri scrollovani
      $('.js-paroller').paroller({
        factor: 0.3, type: 'background', direction: 'vertical'
      });
    },

    productTabsToggle: function( $this, selector ) {

      var $content_wrapper = $this.closest( selector );

      // Toggle menu
      $this.closest("ul").find("a").removeClass("active");
      $this.addClass("active");
      // Toggle content
      $content_wrapper.find(".product-tabs-content").removeClass("active");
      $content_wrapper.find('[data-id="'+ $this.data("id") +'"]').addClass("active");

    },

    productTabsAjax: function( id ) {
      var self = this;

      // Pokud ajax bezi, stopnem to a pockame na vysledek
      if( self.ajaxProductTabs ) {
        return false;
      }
      self.ajaxProductTabs = true;

      // Zobrazime loader
      self.$jsAjaxEqpContent.addClass("loading");

      $.ajax({
        url: ajaxCore.ajax_url,
        method: "POST",
        cache: false,
        data: {
          action: 'j3w_product_tabs',
          drone_id: id
        }
      })
      .done(function( data ){
        if ( data === "" ) {
          self.$jsAjaxEqpContent.html( data ).hide();
        }
        else {
          self.$jsAjaxEqpContent.html( data ).show().removeClass("loading");
        }
        self.ajaxProductTabs = false;
        // var lazyLoadInstance definujeme dole ve footer.php
        //console.log( lazyLoadInstance );
        lazyLoadInstance.update();
      })
      .fail(function( jqXHR, textStatus ){
        console.log( 'SITg: AJAX error - ajaxProductTabs() - ' + textStatus );
        self.ajaxProductTabs = false;
      });

    }
};

$(document).ready(function () {
    new J3WTheme();
});
